var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-id-component"},[_c('span',{staticClass:"cell-id",on:{"click":_vm.truncate}},[_vm._v(" "+_vm._s(_vm.truncatedId)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }